import { render, staticRenderFns } from "./legalPerson.vue?vue&type=template&id=dcf83e60&scoped=true&"
import script from "./legalPerson.vue?vue&type=script&lang=js&"
export * from "./legalPerson.vue?vue&type=script&lang=js&"
import style0 from "./legalPerson.vue?vue&type=style&index=0&id=dcf83e60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf83e60",
  null
  
)

export default component.exports